import React from "react";

function replaceNewLines(str: string) {
  return str.length ? (
    <React.Fragment key={Math.random()}>
      {str.split("\n").map((line, i) =>
        i === 0 ? (
          line || " "
        ) : (
          <React.Fragment key={Math.random()}>
            <br />
            {line || " "}
          </React.Fragment>
        ),
      )}
    </React.Fragment>
  ) : null;
}

export default replaceNewLines;
